import * as React from "react";
function SvgArrow(props, svgRef) {
  return <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><g style={{
      fill: "var(--svg-color, var(--default-svg-color, #000))"
    }}><path fillRule="evenodd" clipRule="evenodd" d="M15.1945 18.3061L15.7249 17.7758L20.7506 12.75L1.12806 12.75L0.378059 12.75L0.378059 11.25L1.12806 11.25L20.7506 11.25L15.7249 6.22422L15.1945 5.69389L16.2552 4.63323L16.7855 5.16356L23.0916 11.4697L23.6219 12L23.0916 12.5303L16.7855 18.8364L16.2552 19.3668L15.1945 18.3061Z" /></g></svg>;
}
const ForwardRef = React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "src/assets/icons/arrow.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/arrow_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/arrow_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/arrow_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/arrow_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/arrow_4x.svg"
};
export { ForwardRef as ReactComponent };